import { h, FunctionalComponent } from 'preact'
import { route } from 'preact-router'
import tdlib from '../../utils/tdlib'
import { getConnectionTextByState } from '../../utils/auth'
import { MAIN_MENU } from '../../constants/menu'
import { ROUTE } from '../../constants/routes'
import { ConnectionState } from '../../types/auth'
import Menu from '../../UI/Menu'
import Search from '../Search'
import { Loader } from '../../UI/Loader'
import MenuItem from '../../UI/MenuItem'
import Notice from '../../UI/Notice'
import ChatList from '../ChatList'
import s from './Chats.css'

interface iProps {
  connectionState: ConnectionState
}

const Chats: FunctionalComponent<iProps> = ({ connectionState }) => {
  if (connectionState === ConnectionState.connecting) {
    return (
      <div className={s.Chats}>
        <div className={s.Chats__loader}>
          <Loader
            size="l"
            color="blue"
          />
        </div>
      </div>
    )
  }

  return (
    <div className={s.Chats}>
      <div className={s.Chats__header}>
        <Menu>
          {MAIN_MENU.map(({ label, event }) => (
            <MenuItem
              key={label}
              onClick={() => {
                tdlib.send({ '@type': event })
                route(ROUTE.HOME, true);
              }}
            >
              {label}
            </MenuItem>
          ))}
        </Menu>
        <div className={s.Chats__search}>
          <Search/>
        </div>
      </div>

      {connectionState !== ConnectionState.ready && (
        <Notice className={s.Chats__notice}>
          {getConnectionTextByState(connectionState)}
        </Notice>
      )}

      <ChatList/>
    </div>
  )
}

export default Chats
